var _desc, _defs, _g, _use, _path, _g2, _use2, _use3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResilience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "232px",
    height: "196px",
    viewBox: "0 0 232 196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-resilience") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.083333,1.000000),rotate(90.000000),scale(1.000000,12.250247),translate(-0.489155,-0.509384)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "71.3359426%",
    x2: "19.6413923%",
    y2: "21.3092469%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.21875%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "18.8951647%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.29754382,37.1361201 L57.1220956,0.44364189 C57.5624272,0.154219849 58.0778378,8.09040156e-15 58.6047695,0 L151.395082,0 C151.922014,-3.36246786e-15 152.437424,0.154219849 152.877756,0.44364189 L208.702308,37.1361201 C209.948132,37.9549782 210.294257,39.6287342 209.475399,40.8745587 C209.42387,40.9529549 209.36829,41.0286117 209.308884,41.1012209 L107.089176,166.04012 C106.145136,167.193981 104.444451,167.364074 103.29059,166.420034 C103.151633,166.306345 103.024364,166.179077 102.910675,166.04012 L0.690967301,41.1012209 C-0.253072918,39.9473598 -0.0829794813,38.2466748 1.07088162,37.3026345 C1.14349086,37.2432287 1.21914759,37.1876485 1.29754382,37.1361201 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29754382,37.1361201 L57.1220956,0.44364189 C57.5624272,0.154219849 58.0778378,8.09040156e-15 58.6047695,0 L151.395082,0 C151.922014,-3.36246786e-15 152.437424,0.154219849 152.877756,0.44364189 L208.702308,37.1361201 C209.948132,37.9549782 210.294257,39.6287342 209.475399,40.8745587 C209.42387,40.9529549 209.36829,41.0286117 209.308884,41.1012209 L107.089176,166.04012 C106.145136,167.193981 104.444451,167.364074 103.29059,166.420034 C103.151633,166.306345 103.024364,166.179077 102.910675,166.04012 L0.690967301,41.1012209 C-0.253072918,39.9473598 -0.0829794813,38.2466748 1.07088162,37.3026345 C1.14349086,37.2432287 1.21914759,37.1876485 1.29754382,37.1361201 Z M47.1328409,19.2998759 L15.671469,39.5246176 C15.6278961,39.5526282 15.5859421,39.5830803 15.5458079,39.6158283 C14.9578666,40.0955661 14.8701503,40.9610911 15.3498881,41.5490324 L60.4938748,96.8751217 C60.7460857,95.5587973 60.7959093,93.8491763 60.7959093,91.6417835 L60.7959093,32.5521658 C60.7959093,24.8027077 60.1818388,23.3496843 52.3524401,23.3496843 L47.1328409,23.3496843 L47.1328409,19.2998759 Z M135.728671,10 C148.818067,13.5167531 155.362764,21.7386348 155.362764,34.9738714 C155.362764,47.0823996 147.686883,55.80054 133.563262,58.8680338 C150.450201,60.9668453 151.524824,69.2006445 151.524824,90.3502072 C151.524824,91.808845 151.55871,93.1106811 151.642147,94.2572132 L194.65002,41.5490324 C194.682768,41.5088982 194.71322,41.4669442 194.741231,41.4233714 C195.151568,40.7850557 194.966755,39.9349547 194.328439,39.5246176 L148.400289,10 L135.728671,10 Z M132.791507,117.359563 C122.797761,114.287793 118.2115,106.585527 118.2115,93.256254 L118.2115,84.2152195 C118.2115,70.976562 116.676324,67.4247271 104.087879,67.4247271 L94.8768214,67.4247271 L94.8768214,91.6417835 C94.8768214,99.3912416 95.4908919,101.005712 103.320291,101.005712 L109.15396,101.005712 L109.15396,116.343181 L76.3790715,116.343181 L104.467673,150.76709 C104.496942,150.80296 104.529762,150.835781 104.565633,150.86505 C104.859604,151.104919 105.292366,151.06106 105.532235,150.76709 L132.791507,117.359563 Z M93.8605347,52.2264313 L103.194568,52.2264313 C115.376272,52.2264313 120.91341,49.1108662 120.91341,38.8295012 C120.91341,27.769245 116.009088,24.4979017 104.301995,24.4979017 L93.8605347,24.4979017 L93.8605347,52.2264313 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.75,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "32.1500211%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "37.7754807%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.885115607%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.1328409,19.2998759 L47.1328409,23.3496843 L52.3524401,23.3496843 C60.1818388,23.3496843 60.7959093,24.8027077 60.7959093,32.5521658 L60.7959093,91.6417835 C60.7959093,93.8491763 60.7460857,95.5587973 60.4938748,96.8751217 L15.3498881,41.5490324 C14.8701503,40.9610911 14.9578666,40.0955661 15.5458079,39.6158283 C15.5859421,39.5830803 15.6278961,39.5526282 15.671469,39.5246176 L47.1328409,19.2998759 Z M135.728671,10 L148.400289,10 L194.328439,39.5246176 C194.966755,39.9349547 195.151568,40.7850557 194.741231,41.4233714 C194.71322,41.4669442 194.682768,41.5088982 194.65002,41.5490324 L151.642147,94.2572132 C151.55871,93.1106811 151.524824,91.808845 151.524824,90.3502072 C151.524824,69.2006445 150.450201,60.9668453 133.563262,58.8680338 C147.686883,55.80054 155.362764,47.0823996 155.362764,34.9738714 C155.362764,21.7386348 148.818067,13.5167531 135.728671,10 Z M132.791507,117.359563 L105.532235,150.76709 C105.292366,151.06106 104.859604,151.104919 104.565633,150.86505 C104.529762,150.835781 104.496942,150.80296 104.467673,150.76709 L76.3790715,116.343181 L109.15396,116.343181 L109.15396,101.005712 L103.320291,101.005712 C95.4908919,101.005712 94.8768214,99.3912416 94.8768214,91.6417835 L94.8768214,67.4247271 L104.087879,67.4247271 C116.676324,67.4247271 118.2115,70.976562 118.2115,84.2152195 L118.2115,93.256254 C118.2115,106.585527 122.797761,114.287793 132.791507,117.359563 Z M93.8605347,52.2264313 L93.8605347,24.4979017 L104.301995,24.4979017 C116.009088,24.4979017 120.91341,27.769245 120.91341,38.8295012 C120.91341,49.1108662 115.376272,52.2264313 103.194568,52.2264313 L93.8605347,52.2264313 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.1%",
    y: "-5.3%",
    width: "108.2%",
    height: "110.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH-??-(Mental-Health-Quiz)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mental-Health-Assess-LG-03.0.0",
    transform: "translate(-301.000000, -543.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R-&-PS",
    transform: "translate(161.000000, 483.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "resilience",
    transform: "translate(64.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic-resilience",
    transform: "translate(64.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(23.000000, 7.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "double-shadow-01",
    transform: "translate(9.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    fill: "url(#radialGradient-1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 96,
    cy: 6,
    rx: 96,
    ry: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-small",
    transform: "translate(42.000000, 0.000000)",
    fill: "url(#radialGradient-2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    cx: 54,
    cy: 4.5,
    rx: 54,
    ry: 4.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#path-6"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-5)",
    strokeWidth: 10.7976269,
    d: "M-1.66780383,32.6245904 L54.156748,-4.06788778 C55.4777426,-4.9361539 57.0239744,-5.39881345 58.6047695,-5.39881345 L151.395082,-5.39881345 C152.975877,-5.39881345 154.522109,-4.9361539 155.843104,-4.06788778 L211.667655,32.6245904 C215.405129,35.0811648 216.443503,40.1024328 213.986928,43.8399064 C213.832343,44.0750951 213.665602,44.3020653 213.487385,44.519893 L111.267677,169.458792 C108.435556,172.920375 103.333501,173.430655 99.8719177,170.598535 C99.4550463,170.257468 99.0732412,169.875663 98.7321747,169.458792 L-3.48753339,44.519893 C-6.31965405,41.0583096 -5.80937374,35.9562545 -2.34779042,33.1241338 C-2.12996272,32.9459165 -1.90299253,32.7791757 -1.66780383,32.6245904 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shine"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#575756",
    opacity: 0,
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-9)",
    mask: "url(#mask-8)",
    cx: 105,
    cy: 93.5,
    rx: 105,
    ry: 57.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#2CB5D6",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    },
    xlinkHref: "#path-12"
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-11)",
    strokeWidth: 2.40447154,
    d: "M48.3350767,22.1474485 L52.3524401,22.1474485 C60.5825296,22.1474485 61.9981451,23.8128122 61.9981451,32.5521658 L61.9981451,91.6417835 C61.9981451,94.285943 61.9204943,95.8181689 61.6746322,97.1013577 L61.1901267,99.6300603 L14.4183964,42.3090943 C13.518888,41.2067043 13.6833561,39.583845 14.7857461,38.6843366 C14.8609977,38.6229341 14.9396614,38.5658363 15.0213605,38.5133166 L48.3350767,17.0978072 L48.3350767,22.1474485 Z M126.620511,8.79776423 L148.753381,8.79776423 L194.978547,38.5133166 C196.175389,39.2826986 196.521914,40.876638 195.752532,42.0734798 C195.700012,42.1551789 195.642914,42.2338426 195.581512,42.3090943 L150.662493,97.3594742 L150.443082,94.3444729 C150.360532,93.2101294 150.322588,91.9030295 150.322588,90.3502072 C150.322588,77.6892718 149.787923,72.1478366 147.792509,67.9847238 C145.599375,63.4090974 141.434466,61.0578006 133.414982,60.0610903 L126.412665,59.1907997 L133.308099,57.6931881 C146.77769,54.7677423 154.160529,46.5991847 154.160529,34.9738714 C154.160529,22.3278288 148.025817,14.548769 135.416727,11.1610605 L126.620511,8.79776423 Z M107.951724,115.140945 L107.951724,102.207948 L103.320291,102.207948 C95.129302,102.207948 93.6745856,100.444725 93.6745856,91.6417835 L93.6745856,66.2224913 L104.087879,66.2224913 C116.819718,66.2224913 119.413736,69.5923775 119.413736,84.2152195 L119.413736,93.256254 C119.413736,106.142371 123.738556,113.31922 133.144729,116.210387 L134.852542,116.735316 L106.463727,151.527152 C105.804087,152.335571 104.61399,152.456181 103.805571,151.796541 C103.706927,151.716051 103.616671,151.625796 103.536181,151.527152 L73.8464195,115.140945 L107.951724,115.140945 Z M92.658299,53.4286671 L92.658299,23.2956659 L104.301995,23.2956659 C117.078722,23.2956659 122.115646,27.4165881 122.115646,38.8295012 C122.115646,49.4725597 116.543916,53.4286671 103.194568,53.4286671 L92.658299,53.4286671 Z"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResilience);
export default __webpack_public_path__ + "static/media/resilience.5202e21eb7c51b4951ce38bffd1f7c43.svg";
export { ForwardRef as ReactComponent };